import PaymentsListPage from './PaymentsListPage';

export default PaymentsListPage;
